import styled from "styled-components";
import RoleCard from "./RoleCard";
import ListPage from "../../../customUiForCs/ListPage";
import { FiTool } from "react-icons/fi";
import { BiPlus } from "react-icons/bi";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 30px;
  width: 100%;
  margin-top: 30px;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const Content = styled.div`
  padding: 15px;
  border: 1px solid var(--borderDim);
  background: var(--surface2);
  border-radius: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const BottomPart = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export default function RoleListPage() {
  return (
    <ListPage
      permissionName={"rolePermissions"}
      buttons={[
        {
          href: "/add-role",
          text: "Ajouter un nouveau rôle",
          icon: <BiPlus />,
        },
      ]}
      CardComponent={RoleCard}
      titleLine1={"Liste des"}
      titleLine2={"Rôles"}
      path="roles"
    />
  );
}
